import config from 'tradera-apps/syi/script/app_react/services/config';
import userData from 'tradera-apps/syi/script/app_react/services/user-data';
import { getSyiSlice } from 'tradera-state/configure-store';

const updatePrices = () => (dispatch, getState) => {
    const priceInfo = {
        auctionCommission: 0,
        fixedPriceCommission: 0,
        featureFees: [],
        feesTotal: 0
    };

    const state = getSyiSlice(getState());

    const commissionShare = 0.1;
    const commissionMinimum = config.commissionMinimum;
    const commissionCap = config.commissionCap;

    if (state.price.openingBid) {
        priceInfo.auctionCommission = Math.min(
            Math.max(
                state.price.openingBid * commissionShare,
                commissionMinimum
            ),
            commissionCap
        );
    }

    if (state.price.fixedPrice) {
        priceInfo.fixedPriceCommission = Math.min(
            Math.max(
                state.price.fixedPrice * commissionShare,
                commissionMinimum
            ),
            commissionCap
        );
    }

    if (state.price.reservePrice) {
        priceInfo.featureFees.push({
            description: 'Reservationspris',
            price: 40
        });
    }

    if (
        _.isString(state.itemDuration.customEndTimeHour) &&
        _.isString(state.itemDuration.customEndTimeMinute)
    ) {
        priceInfo.featureFees.push({
            description: 'Vald sluttid',
            price: state.itemDuration.customEndTimePrice
        });
    }

    if (state.extraFeatures.shippingBags) {
        const { value: price } =
            config.shippingBagAmountsPrices.find(
                amountPrice =>
                    amountPrice.key === state.extraFeatures.shippingBags
            ) || {};
        if (price) {
            priceInfo.featureFees.push({
                description: 'Fraktpåsar',
                price
            });
        }
    }

    if (state.extraFeatures.displayHighlighted) {
        priceInfo.featureFees.push({
            description: 'Highlight',
            price: config.highlightFeaturePrice
        });
    }

    if (state.extraFeatures.displayPromoted) {
        priceInfo.featureFees.push({
            description: 'Rank up',
            price: 45
        });
    }

    priceInfo.feesTotal = _.reduce(
        priceInfo.featureFees,
        function(memo, fee) {
            return memo + fee.price;
        },
        0
    );

    dispatch({
        type: 'SET_CHOSEN_EXTRA_FEATURES',
        payload: priceInfo.featureFees
    });
};

const setDiscountFactor = discountFactor => ({
    type: 'SET_DISCOUNT_FACTOR',
    discountFactor: discountFactor
});

const resetDiscountFactor = () => ({
    type: 'RESET_DISCOUNT_FACTOR'
});

const setCampaignCommission = campaignCommissionProcent => ({
    type: 'SET_CAMPAIGN_COMMISSION_PROCENT',
    campaignCommissionProcent: campaignCommissionProcent
});

const resetCampaignCommission = () => ({
    type: 'RESET_CAMPAIGN_COMMISSION_PROCENT'
});

const updateMaxCommission = () => (dispatch, getState) => {
    let maxFeeCap = getSyiSlice(getState()).campaignCode.maxFeeCap;
    const isDomainNameCategory =
        getSyiSlice(getState()).category.draftCategoryId ===
        config.domainNameCategoryId;
    if (maxFeeCap === null || isDomainNameCategory) {
        dispatch({
            type: 'SET_MAX_COMMISSION_COST',
            payload: {
                maxCommissionCost: isDomainNameCategory
                    ? undefined
                    : config.commissionCap,
                isCategoryWithNoCommissionCap: isDomainNameCategory
            }
        });
    } else {
        dispatch({
            type: 'SET_MAX_COMMISSION_COST',
            payload: {
                maxCommissionCost: maxFeeCap,
                isCategoryWithNoCommissionCap: false
            }
        });
    }
};

const updateCommission = () => (dispatch, getState) => {
    let campaignCommissionProcent = getSyiSlice(getState()).fees
        .campaignCommissionProcent;
    if (campaignCommissionProcent === null) {
        const isDomainNameCategory =
            getSyiSlice(getState()).category.draftCategoryId ===
            config.domainNameCategoryId;
        if (userData.isCompanyUser) {
            let companyMinCommissionProcent = 5;
            let companyMaxCommissionProcent = 8;
            let discountFactor = getSyiSlice(getState()).fees.discountFactor;
            if (discountFactor !== null) {
                companyMinCommissionProcent =
                    companyMinCommissionProcent * (1 - discountFactor);
                companyMaxCommissionProcent =
                    companyMaxCommissionProcent * (1 - discountFactor);
            }

            let commissionProcent = '0';
            if (companyMaxCommissionProcent > 0) {
                commissionProcent = isDomainNameCategory
                    ? companyMaxCommissionProcent.toString()
                    : companyMinCommissionProcent +
                      ' - ' +
                      companyMaxCommissionProcent;
            }

            dispatch({
                type: 'SET_COMMISSION_PROCENT',
                commissionProcent: commissionProcent
            });
            dispatch({
                type: 'SET_IS_VARIABLE_COMMISSION',
                payload: true
            });
        } else {
            dispatch({
                type: 'SET_COMMISSION_PROCENT',
                commissionProcent: '10'
            });
            dispatch({
                type: 'SET_IS_VARIABLE_COMMISSION',
                payload: false
            });
        }
    } else {
        dispatch({
            type: 'SET_COMMISSION_PROCENT',
            commissionProcent: campaignCommissionProcent
        });
        dispatch({
            type: 'SET_IS_VARIABLE_COMMISSION',
            payload: false
        });
    }
};

export default {
    updatePrices,
    updateCommission,
    setDiscountFactor,
    resetDiscountFactor,
    setCampaignCommission,
    resetCampaignCommission,
    updateMaxCommission
};
